import React from 'react'

import Box from '@material-ui/core/Box';
// import Copyright from '../copyright'

import './footer.css'

const Footer = () => (
  <Box mt={8} className="app-footer">
    {/* <Copyright /> */}
  </Box>
)

export default Footer;
